/** 模板的高频视觉替换入口：让设计师不用在十几页里逐页找素材。 */
import { Alert, Button, Divider, Typography } from 'antd';
import { AssetInput } from '../panel/setters/AssetInput';
import { useEditorStore } from '../store/store';

const { Text } = Typography;

export function DesignTab() {
  const doc = useEditorStore((s) => s.doc);
  const {
    beginBatch, endBatch, setCurrentPage, setLeftTab, setPageProps, setShare, updateLayerProps,
  } = useEditorStore.getState();
  const cover = doc.pages.find((p) => p.id === 'cover');
  const map = doc.pages.find((p) => p.id === 'venue')?.layers.find((l) => l.id === 'venue.map-img');
  const header = doc.pages.flatMap((p) => p.layers).find((l) => l.id.endsWith('.header-bg'));
  const headerIds = doc.pages.flatMap((p) => p.layers).filter((l) => l.id.endsWith('.header-bg')).map((l) => l.id);

  // 批量替换保留为一次撤销，所有内页保持同一套视觉。
  const replaceHeaders = (src: string) => {
    beginBatch();
    for (const id of headerIds) updateLayerProps(id, { src });
    endBatch();
  };

  const openIcons = () => {
    setCurrentPage('cover');
    setLeftTab('layers');
  };

  return (
    <div style={{ padding: 12 }}>
      <Alert type="info" showIcon message="设计交接：替换这五类素材即可换风格，版式与交互不变。" style={{ marginBottom: 14 }} />

      <AssetSection number="1" title="封面页背景 / 主视觉海报">
        {cover ? <AssetInput value={cover.background.type === 'image' ? cover.background.src : ''} accept="image/*" preview="image"
          onChange={(src) => setPageProps('cover', { background: { type: 'image', src, color: '#1B3FBF', fit: 'cover' } })} /> : <Text type="secondary">当前作品不含模板封面。</Text>}
      </AssetSection>

      <AssetSection number="2" title="内页页头背景带">
        {header ? <AssetInput value={String(header.props.src ?? '')} accept="image/*" preview="image" onChange={replaceHeaders} /> : <Text type="secondary">当前作品不含模板页头背景。</Text>}
      </AssetSection>

      <AssetSection number="3" title="场地平面图">
        {map ? <AssetInput value={String(map.props.src ?? '')} accept="image/*" preview="image" onChange={(src) => updateLayerProps(map.id, { src })} /> : <Text type="secondary">当前作品不含场地图占位。</Text>}
      </AssetSection>

      <AssetSection number="4" title="六宫格与项目图标">
        <Text type="secondary" style={{ display: 'block', marginBottom: 8 }}>图标已按用途命名；可在图层中替换图片，尺寸和点击热区会保留。</Text>
        <Button size="small" onClick={openIcons}>前往封面图层</Button>
      </AssetSection>

      <AssetSection number="5" title="分享封面图">
        <AssetInput value={doc.globals.share.image} accept="image/*" preview="image" onChange={(image) => setShare({ image })} />
      </AssetSection>
    </div>
  );
}

function AssetSection({ number, title, children }: { number: string; title: string; children: React.ReactNode }) {
  return <section>
    <Divider style={{ margin: '12px 0 10px' }} />
    <div style={{ fontWeight: 600, fontSize: 13, marginBottom: 8 }}>{number}. {title}</div>
    {children}
  </section>;
}
